<template>
    <el-select v-model="departmentId" :size="size">
        <el-option v-for="department in departments" :key="department.id"
                   :value="department.id" :label="department.name" >
        </el-option>
    </el-select>
</template>

<script>
    import CommonApi from "@/api/common";

    export default {
        name: "operation-board-department-select",
        props: {
            value: {},
            size: {},
        },
        data() {
            return {
                departmentId: null,
                departments: [],
            };
        },
        watch: {
            'value': {
                immediate: true,
                handler() {
                    this.departmentId = this.value;
                },
            },
            'departmentId': {
                handler() {
                    this.change(this.departmentId);
                },
            },
        },
        methods: {
            async load() {
                let departments = await CommonApi.getRunningDeptListByAuth();
                departments = departments == null ? [] : departments;
                let departmentId = null;
                if (departments.length >= 1) {
                    departmentId = departments[0].id;
                }
                this.departmentId = departmentId;
                this.departments = departments;
                return Promise.resolve({
                    departmentId: departmentId,
                    departments: departments,
                });
            },
            change(value) {
                this.$emit('input', value);
                this.$emit('change', value);
            },
        },
    }
</script>

<style scoped>

</style>
